"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _lodash = _interopRequireDefault(require("lodash"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getFieldName = function getFieldName(_ref) {
  var field = _ref.field;
  var parts = field.split('.');
  var camelCaseParts = parts.map(function (part) {
    return _lodash["default"].camelCase(part);
  });
  return camelCaseParts.join('.');
};

var Form = function Form(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["children"]);
  return _react["default"].createElement(_formik.Formik, (0, _extends2["default"])({}, props, {
    render: function render(renderProps) {
      var setErrors = renderProps.setErrors;
      return children(_objectSpread({}, renderProps, {
        setMutationErrors: function setMutationErrors() {
          var serverErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          // Clear existing errors from previous submissions.
          var errors = {}; // This will override errors so that the first error for a given field
          // shows first.

          _lodash["default"].forEachRight(serverErrors, function (serverError) {
            _lodash["default"].set(errors, getFieldName(serverError), serverError.message);
          }); // Update the errors object all in one go to trigger one re-render.


          setErrors(errors);
        }
      }));
    }
  }));
}; // --------------------------------------------------
// Props
// --------------------------------------------------


Form.propTypes = {};
Form.defaultProps = {};
var _default = Form;
exports["default"] = _default;